import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { HHIEButton } from '../utility/HHIEButton';
import Loading from '../utility/Loading';

export default function ProvisionNewMembers() {
    const [show, setShow] = useState(false);
    // const [closeDisabled, setCloseDisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [resultMessage, setResultMessage] = useState("Press 'Run' to check and provision newly added members.");
    var disabled = false;
    useEffect(() => {
        if (loading) {
            disabled = true;
            setResultMessage(<Loading message={<div>Checking for new members to provision. . . please wait</div>} />);
            fetch('api/Member/provisionNewMembers')
                .then((response) => {
                    response.json()
                        .then((result) => {
                            if (result.errors !== null && result.errors !== "") alert(result.errors);
                            if (result.message === true) {
                                setResultMessage("Members were successfully provisioned! This window can be closed now.");
                            } else {
                                setResultMessage("Something went wrong with the provisioning");
                            }
                        })
                        .catch((error) => {
                            console.log("json error: " + error);
                        })
                })
                .catch((error) => {
                    console.log("Response error: " + error);
                });
            setLoading(false);
            disabled = false;
        }
    }, [loading]);

    const handleClose = () => {
        setLoading(false);
        setShow(false);
        setResultMessage("Press 'Run' to check and provision newly added members.");
    };
    const handleShow = () => setShow(true);

    const handleProvisioning = () => {
        setLoading(true);
    };

    return (
        <>
            <HHIEButton
                id="new-member-provision"
                variant="outline-primary"
                onClick={handleShow}
                title="Provision Newly Added Members"
            />
            <Modal
                id="new-member-provision-modal"
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title>Provision Newly Added Members</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>{resultMessage}</div>
                </Modal.Body>
                <Modal.Footer>
                    <HHIEButton
                        variant="warning"
                        disabled={disabled}
                        onClick={handleClose}
                        title="Close"
                    />
                    <HHIEButton
                        variant="primary"
                        onClick={handleProvisioning}
                        title="Run"
                    />
                </Modal.Footer>
            </Modal>
        </>
    );
}